module.exports = __webpack_public_path__ + "img/fengshimeng_p.3c27d18e.png";